import TopBar from 'components/TopBar/index';
import { FaSpinner } from 'react-icons/fa';
import Entry from 'components/Entry';
import { EntryModel } from 'lib/models';

interface HomeMobileProps {
  manifestation?: string;
  isLoading: boolean;
  model: EntryModel|null;
}

const HomeMobile = ({
  manifestation,
  isLoading,
  model,
}: HomeMobileProps) => {

  return (
      <div className="h-screen w-screen flex flex-col bg-palette-5" >
        <TopBar manifestation={manifestation} onMenuOpen={() => console.log("open")}/>
        <div className="flex-1 flex flex-col h-full w-full space-y-2 p-2">
          <div className="h-full w-full rounded-lg border-2 border-palette-3 bg-palette-4 overflow-hidden">
            {isLoading || !(model?.uuid && model?.data) ? (
              <div className="flex flex-col justify-center items-center h-full w-full">
              <FaSpinner />
                Loading...
              </div>
            ) : (
              <Entry uuid={model.uuid} data={model.data} />
            )}
          </div>
        </div>
      </div>
  );
};

export default HomeMobile;
